type Props = {
  on: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  title?: string;
};

export function Toggle({ on, onChange, disabled, title }: Props) {
  return (
    <button
      type="button"
      title={title}
      disabled={disabled}
      onClick={() => onChange(!on)}
      style={{
        width: 38,
        height: 22,
        borderRadius: 999,
        background: on ? "var(--brand-700)" : "var(--n-200)",
        border: "none",
        cursor: disabled ? "default" : "pointer",
        position: "relative",
        transition: "background .15s",
        opacity: disabled ? 0.5 : 1,
        padding: 0,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 2,
          left: on ? 18 : 2,
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: "#fff",
          boxShadow: "0 1px 3px rgba(0,0,0,.2)",
          transition: "left .15s",
        }}
      />
    </button>
  );
}
